tinymce.addI18n('pt_BR',{
"Cut": "Recortar",
"Heading 5": "Cabe\u00e7alho 5",
"Header 2": "Cabe\u00e7alho 2",
"Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X\/C\/V keyboard shortcuts instead.": "Seu navegador n\u00e3o suporta acesso direto \u00e0 \u00e1rea de transfer\u00eancia. Por favor use os atalhos Ctrl+X - C - V do teclado",
"Heading 4": "Cabe\u00e7alho 4",
"Div": "Div",
"Heading 2": "Cabe\u00e7alho 2",
"Paste": "Colar",
"Close": "Fechar",
"Font Family": "Fonte",
"Pre": "Pre",
"Align right": "Alinhar \u00e0 direita",
"New document": "Novo documento",
"Blockquote": "Aspas",
"Numbered list": "Lista ordenada",
"Heading 1": "Cabe\u00e7alho 1",
"Headings": "Cabe\u00e7alhos",
"Increase indent": "Aumentar recuo",
"Formats": "Formatos",
"Headers": "Cabe\u00e7alhos",
"Select all": "Selecionar tudo",
"Header 3": "Cabe\u00e7alho 3",
"Blocks": "Blocos",
"Undo": "Desfazer",
"Strikethrough": "Riscar",
"Bullet list": "Lista n\u00e3o ordenada",
"Header 1": "Cabe\u00e7alho 1",
"Superscript": "Sobrescrito",
"Clear formatting": "Limpar formata\u00e7\u00e3o",
"Font Sizes": "Tamanho",
"Subscript": "Subscrever",
"Header 6": "Cabe\u00e7alho 6",
"Redo": "Refazer",
"Paragraph": "Par\u00e1grafo",
"Ok": "Ok",
"Bold": "Negrito",
"Code": "C\u00f3digo",
"Italic": "It\u00e1lico",
"Align center": "Centralizar",
"Header 5": "Cabe\u00e7alho 5",
"Heading 6": "Cabe\u00e7alho 6",
"Heading 3": "Cabe\u00e7alho 3",
"Decrease indent": "Diminuir recuo",
"Header 4": "Cabe\u00e7alho 4",
"Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "O comando colar est\u00e1 agora em modo texto plano. O conte\u00fado ser\u00e1 colado como texto plano at\u00e9 voc\u00ea desligar esta op\u00e7\u00e3o.",
"Underline": "Sublinhar",
"Cancel": "Cancelar",
"Justify": "Justificar",
"Inline": "Em linha",
"Copy": "Copiar",
"Align left": "Alinhar \u00e0 esquerda",
"Visual aids": "Ajuda visual",
"Lower Greek": "\u03b1. \u03b2. \u03b3. ...",
"Square": "Quadrado",
"Default": "Padr\u00e3o",
"Lower Alpha": "a. b. c. ...",
"Circle": "C\u00edrculo",
"Disc": "Disco",
"Upper Alpha": "A. B. C. ...",
"Upper Roman": "I. II. III. ...",
"Lower Roman": "i. ii. iii. ...",
"Name": "Nome",
"Anchor": "\u00c2ncora",
"You have unsaved changes are you sure you want to navigate away?": "Voc\u00ea tem mudan\u00e7as n\u00e3o salvas. Voc\u00ea tem certeza que deseja sair?",
"Restore last draft": "Restaurar \u00faltimo rascunho",
"Special character": "Caracteres especiais",
"Source code": "C\u00f3digo fonte",
"B": "B",
"R": "R",
"G": "G",
"Color": "Cor",
"Right to left": "Da direita para a esquerda",
"Left to right": "Da esquerda para a direita",
"Emoticons": "Emoticons",
"Robots": "Rob\u00f4s",
"Document properties": "Propriedades do documento",
"Title": "T\u00edtulo",
"Keywords": "Palavras-chave",
"Encoding": "Codifica\u00e7\u00e3o",
"Description": "Descri\u00e7\u00e3o",
"Author": "Autor",
"Fullscreen": "Tela cheia",
"Horizontal line": "Linha horizontal",
"Horizontal space": "Espa\u00e7amento horizontal",
"Insert\/edit image": "Inserir\/editar imagem",
"General": "Geral",
"Advanced": "Avan\u00e7ado",
"Source": "Endere\u00e7o da imagem",
"Border": "Borda",
"Constrain proportions": "Manter propor\u00e7\u00f5es",
"Vertical space": "Espa\u00e7amento vertical",
"Image description": "Inserir descri\u00e7\u00e3o",
"Style": "Estilo",
"Dimensions": "Dimens\u00f5es",
"Insert image": "Inserir imagem",
"Zoom in": "Aumentar zoom",
"Contrast": "Contraste",
"Back": "Voltar",
"Gamma": "Gama",
"Flip horizontally": "Virar horizontalmente",
"Resize": "Redimensionar",
"Sharpen": "Aumentar nitidez",
"Zoom out": "Diminuir zoom",
"Image options": "Op\u00e7\u00f5es de Imagem",
"Apply": "Aplicar",
"Brightness": "Brilho",
"Rotate clockwise": "Girar em sentido anti-hor\u00e1rio",
"Rotate counterclockwise": "Girar em sentido hor\u00e1rio",
"Edit image": "Editar imagem",
"Color levels": "N\u00edveis de cor",
"Crop": "Cortar",
"Orientation": "Orienta\u00e7\u00e3o",
"Flip vertically": "Virar verticalmente",
"Invert": "Inverter",
"Insert date\/time": "Inserir data\/hora",
"Remove link": "Remover link",
"Url": "Url",
"Text to display": "Texto para mostrar",
"Anchors": "\u00c2ncoras",
"Insert link": "Inserir link",
"New window": "Nova janela",
"None": "Nenhum",
"The URL you entered seems to be an external link. Do you want to add the required http:\/\/ prefix?": "A URL que voc\u00ea informou parece ser um link externo. Deseja incluir o prefixo http:\/\/?",
"Target": "Alvo",
"The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?",
"Insert\/edit link": "Inserir\/editar link",
"Insert\/edit video": "Inserir\/editar v\u00eddeo",
"Poster": "Autor",
"Alternative source": "Fonte alternativa",
"Paste your embed code below:": "Insira o c\u00f3digo de incorpora\u00e7\u00e3o abaixo:",
"Insert video": "Inserir v\u00eddeo",
"Embed": "Incorporar",
"Nonbreaking space": "Espa\u00e7o n\u00e3o separ\u00e1vel",
"Page break": "Quebra de p\u00e1gina",
"Paste as text": "Colar como texto",
"Preview": "Pr\u00e9-visualizar",
"Print": "Imprimir",
"Save": "Salvar",
"Could not find the specified string.": "N\u00e3o foi poss\u00edvel encontrar o termo especificado",
"Replace": "Substituir",
"Next": "Pr\u00f3ximo",
"Whole words": "Palavras inteiras",
"Find and replace": "Localizar e substituir",
"Replace with": "Substituir por",
"Find": "Localizar",
"Replace all": "Substituir tudo",
"Match case": "Diferenciar mai\u00fasculas e min\u00fasculas",
"Prev": "Anterior",
"Spellcheck": "Corretor ortogr\u00e1fico",
"Finish": "Finalizar",
"Ignore all": "Ignorar tudo",
"Ignore": "Ignorar",
"Add to Dictionary": "Adicionar ao Dicion\u00e1rio",
"Insert row before": "Inserir linha antes",
"Rows": "Linhas",
"Height": "Altura",
"Paste row after": "Colar linha depois",
"Alignment": "Alinhamento",
"Border color": "Cor da borda",
"Column group": "Agrupar coluna",
"Row": "Linha",
"Insert column before": "Inserir coluna antes",
"Split cell": "Dividir c\u00e9lula",
"Cell padding": "Espa\u00e7amento interno da c\u00e9lula",
"Cell spacing": "Espa\u00e7amento da c\u00e9lula",
"Row type": "Tipo de linha",
"Insert table": "Inserir tabela",
"Body": "Corpo",
"Caption": "Legenda",
"Footer": "Rodap\u00e9",
"Delete row": "Excluir linha",
"Paste row before": "Colar linha antes",
"Scope": "Escopo",
"Delete table": "Excluir tabela",
"H Align": "Alinhamento H",
"Top": "Superior",
"Header cell": "C\u00e9lula cabe\u00e7alho",
"Column": "Coluna",
"Row group": "Agrupar linha",
"Cell": "C\u00e9lula",
"Middle": "Meio",
"Cell type": "Tipo de c\u00e9lula",
"Copy row": "Copiar linha",
"Row properties": "Propriedades da linha",
"Table properties": "Propriedades da tabela",
"Bottom": "Inferior",
"V Align": "Alinhamento V",
"Header": "Cabe\u00e7alho",
"Right": "Direita",
"Insert column after": "Inserir coluna depois",
"Cols": "Colunas",
"Insert row after": "Inserir linha depois",
"Width": "Largura",
"Cell properties": "Propriedades da c\u00e9lula",
"Left": "Esquerdo",
"Cut row": "Recortar linha",
"Delete column": "Excluir coluna",
"Center": "Centro",
"Merge cells": "Agrupar c\u00e9lulas",
"Insert template": "Inserir modelo",
"Templates": "Modelos",
"Background color": "Cor do fundo",
"Custom...": "Personalizado...",
"Custom color": "Cor personalizada",
"No color": "Nenhuma cor",
"Text color": "Cor do texto",
"Show blocks": "Mostrar blocos",
"Show invisible characters": "Exibir caracteres invis\u00edveis",
"Words: {0}": "Palavras: {0}",
"Insert": "Inserir",
"File": "Arquivo",
"Edit": "Editar",
"Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "\u00c1rea de texto formatado. Pressione ALT-F9 para exibir o menu, ALT-F10 para exibir a barra de ferramentas ou ALT-0 para exibir a ajuda",
"Tools": "Ferramentas",
"View": "Visualizar",
"Table": "Tabela",
"Format": "Formatar"
});